import React, { useEffect } from "react";
import Modal from "./Modal";

interface RedirectionModalProps {
  link: string;
  duration?: number;
  text: string;
  replace?: boolean;
}

const RedirectionModal: React.FC<RedirectionModalProps> = ({
  link,
  duration = 3000,
  text,
  replace,
}) => {
  useEffect(() => {
    setTimeout(() => {
      if (replace) {
        window.location.replace(link);
      } else {
        window.open(link, "_parent");
      }
    }, duration);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal className="bg-light p-4 border-orange border-t-4 rounded-lg flex flex-col items-center w-84 text-text shadow-xl">
      <span className="font-medium text-dark text-xl">Hold on</span>
      <span className="font-medium text-orange leading-none mb-2">. . .</span>
      <span className="font-medium">
        Taking you to the <strong>{text}</strong>
      </span>
    </Modal>
  );
};

export default RedirectionModal;
